import styled from "styled-components";

export default styled.div`
  display: flex;
  position: relative;
  top: 0;
  z-index: 1;
  /* padding: 0.5rem 0.75rem; */
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .image-content {
    .image-conatiner {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      overflow: hidden;

      &--horizontal {
        width: 100%;
        max-width: 600px;
        min-width: 40vw;
        height: auto;

        .image-loading-placeholder {
          display: none;

          &--loading {
            display: block;
          }
        }

        .image-item {
          opacity: 1;

          &--loading {
            opacity: 0;
            position: absolute;
          }
        }

        .image-item {
          width: 100%;
          height: auto;
          object-fit: contain;

          &--loading {
            position: absolute;
            opacity: 0;
          }
        }

        .image-loading-placeholder {
          display: none;

          &--loading {
            display: block;
            max-height: 337.5px;
            min-height: 22.5vw;
            height: 100%;
            width: 100%;
            object-fit: contain;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }

      &--vertical {
        max-height: 500px;
        min-height: 350px;
        height: 40vw;
        width: auto;

        .image-item {
          width: auto;
          height: 100%;
          object-fit: contain;

          &--loading {
            opacity: 0;
            position: absolute;
          }
        }

        .image-loading-placeholder {
          display: none;

          &--loading {
            display: block;
            max-width: 381.25px;
            width: 30.5vw;
            height: 100%;

            object-fit: contain;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }

  .hour-cont {
    position: absolute;
    width: 100%;
    bottom: 10px;
    left: -10px;

    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
`;
